var TabsBox = function(){

    'use strict';

    var $ = jQuery;
    var instances = [];

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            $tabContent = $view.find('#tab-content'),
            $tabMenu = $view.find('#tab-menu'),
            id = $view.data('id'),
            currentTab = 1;

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        /**
         * setMaxHeight
         * Setea el alto máximo general de todos los item (pestañas)
         */
        function setMaxHeight() {
            var max = 0;

            $tabContent.find('.item').each(function () {
                if ($(this).height() > max) {
                    max = $(this).outerHeight();
                }
            });

            // $tabContent.find('.tab-content-container').css('min-height', max);
            $tabContent.find('.tab-content-container').css('min-height', 350);

        }

        /**
         * setCountSpace
         * Setea el ancho del "contador" definido por el índice del boton clicado
         * @param {int} index
         */
        function setCountSpace(index) {
            var finalWidth = 0;

            // Reset all li i colors
            var secondaryColor = $($tabMenu.find('li').get(0)).data('secondary-color');

            $tabMenu
                .find('li i')
                .css({
                    // 'color': secondaryColor,
                    // 'background-color': primaryColor
                });

            for (var i = 0; i < index; i++) {
                var $currentLi = $($tabMenu.find('li').get(i));
                var primaryColor = $currentLi.data('primary-color');
                finalWidth += $currentLi.width();
                $currentLi.find('i').css({
                    // 'color': primaryColor,
                    // 'background-color': secondaryColor
                });
            }

            $view.find('.menu-count')
                .delay(500)
                .width(finalWidth);
        }

        function getTotalHeight($button) {
            var height = 0;
            $button.parent().find('.col-wrapper').children().each(function () {
                height += $(this).innerHeight();
            });
            // $button.parent().find('.col-wrapper').children().height();
            return height; 
        }

        /**
         * accordionClick
         * Evento click en un enlace de tab
         * @param {Object} e
         */
        function accordionClick(e) {
            e.preventDefault();
            e.stopPropagation();
            var $button = $(this);

            if ( ! $button.hasClass('current') ) {
                $button.parent().find('.col-wrapper').animate({
                    height: getTotalHeight($button)
                }, 700, function () {
                    $button.addClass('current');
                    $button.find('a').css({
                        'color': $button.data('primary-color'),
                        'background-color': $button.data('secondary-color')
                    });
                    $button.find('a span').css({
                        // 'color': $button.data('primary-color'),
                    });
                    $button.find('a i').css({
                        'color': $button.data('primary-color'),
                        'background-color': 'white'
                    });
                });
            }
            else {
                var $current = $view.find('div.tab-mobile-button.current');
                $current.parent().find('.col-wrapper').animate({
                    height: 0
                }, 700, function () {
                    $current.removeClass('current');
                    $current.find('a').css('background-color', $current.data('primary-color'));
                    $button.find('a span').css({
                            'color': 'white',
                        });
                    $current.find('a i').css({
                        'color': $current.data('secondaryColor-color'),
                        'background-color': 'white'
                    });
                });
            }
        }

        function setSlide(currentTab, $prevTab, $currentTab) {
            if (Number($prevTab.data('num')) < Number($currentTab.data('num'))) {
                // Animation for prev tab
                $prevTab.removeClass('current').addClass('prev');
                $prevTab.animate({
                    left: -$prevTab.parent().width()
                }, 400, function () {

                });

                // Calculate initial position for current tab
                if ($currentTab.hasClass('prev')) {
                    $currentTab.css('left', $currentTab.parent().width());
                }

                // Animation for current tab
                $currentTab.addClass('current');
                $currentTab.animate({
                    left: 0
                }, 400, function () {

                });
            }
            else if (Number($prevTab.data('num')) > Number($currentTab.data('num'))) {
                // Animation for prev tab
                $prevTab.removeClass('current');
                $prevTab.animate({
                    left: $prevTab.parent().width()
                }, 400, function () {

                });

                // Calculate initial position for current tab
                if ( ! $currentTab.hasClass('prev') ) {
                    $currentTab.css('left', -$prevTab.parent().width());
                }

                // Animation for current tab
                $currentTab.addClass('current').removeClass('prev');
                $currentTab.animate({
                    left: 0
                }, 400, function () {

                });
            }

            setCountSpace(currentTab);
        }

        /**
         * tabClick
         * Evento click en un enlace de pestaña
         * @param {Object} e
         */
        function tabClick(e) {
            e.preventDefault();
            currentTab = Number($(this).data('num'));
            var $prevTab = $tabContent.find('.current');
            var $currentTab = $($tabContent.find('.item').get(currentTab - 1));
            setSlide(currentTab, $prevTab, $currentTab);
        }

        function bindMobile() {
            $view.find('div.tab-mobile-button').on('click', accordionClick);
        }

        function unbindMobile() {
            $view.find('div.tab-mobile-button a').removeClass('current');
            $view.find('div.tab-mobile-button a').css('background-color', $view.find('div.tab-mobile-button a').parents('div.tab-mobile-button').data('primary-color'));
            $view.find('div.tab-mobile-button a span').css({
                    'color': 'white',
                });
            $view.find('#tab-menu a i').css({
                'color': $view.find('#tab-menu a').parents('div.tab-mobile-button').data('primary-color'),
                'background-color': 'white'
            });
            $view.find('.col-wrapper').removeAttr('style');
            $view.find('div.tab-mobile-button').off('click', accordionClick);
        }

        function bindDesktop() {
            $view.find('#tab-menu a').on('click', tabClick);
        }

        function unbindDesktop() {
            $view.find('#tab-menu a').off('click', tabClick);
        }

        function mediaQueryChangeTabs(value) {
            if (value === 'mobile' || value === 'tablet') {
                unbindDesktop();
                unbindMobile();
                bindMobile();
            }
            else if (value === 'desktop') {
                unbindMobile();
                unbindDesktop();
                bindDesktop();
                setCountSpace(1);
                setMaxHeight();

            }
        }

        function initInWindow(id, platform) {
            if ($view.hasClass(id)) {
                if (platform === 'mobile' || platform === 'tablet') {
                    unbindDesktop();
                    unbindMobile();
                    bindMobile();
                }
                else if (platform === 'desktop') {
                    unbindMobile();
                    unbindDesktop();
                    bindDesktop();
                    setCountSpace(1);
                    setMaxHeight();
                    /* @todo: si cuando vuelve a un módulo de pestañas queremos 
                              que se reinicie, descomentar esto las siguientes 
                              lineas */
                    currentTab = Number($($view.find('a[data-num="1"]').get(0)).data('num'));
                    var $prevTab = $tabContent.find('.current');
                    var $currentTab = $($tabContent.find('.item').get(currentTab - 1));
                    setSlide(1, $prevTab, $currentTab);

                }
            }
        }

        // instance object
        var instance = {
            init: function () {
                // Subscribe events
                Events.subscribe('GENERAL_MEDIAQUERY_CHANGE', mediaQueryChangeTabs);
                Events.subscribe('TAB_CONTROLL_ITEM_INIT', initInWindow);
                
                // Trigger events
                Events.publish('GENERAL_MEDIAQUERY_CHECK', [mediaQueryChangeTabs]);

                $(window).resize(function () {
                    setCountSpace(currentTab);
                });

                // Configuramos los colores
                // $view.find('.menu-count').css({
                //     backgroundColor: '#313131'
                // });

                if ($view.hasClass('controlled')) {
                    Events.publish('TAB_CONTROLL_ITEM_INITIATED', [$view]);

                }
            }
        };

        Events.subscribe('TAB_BOX_INIT', instance.init);

        return instance;
    }

    /**
     * onReady
     */
    function onReady() {
        $('.module.tabs-box').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    // DOMContentLoaded
    $(onReady);

}

TabsBox();
